import { memo } from 'react';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

const LoadingOverlay = memo(function LoadingOverlay({ open = false, zIndex = 1300 }) {
  return (
    <Backdrop
      open={open}
      sx={{ color: '#fff', zIndex }}
      aria-hidden={!open}
      role="status"
      aria-live="polite"
      aria-busy={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
});

LoadingOverlay.propTypes = {
  open: PropTypes.bool,
  zIndex: PropTypes.number,
};

export default LoadingOverlay;
